import '../css/index.scss';
import SPlayer from './player';
console.log('\n'.concat(' %c SPlayer v', SPLAYER_VERSION, ' %c http://splayer.js.org ', '\n'), 'color: #86E5E4; background: #030307; padding:5px 0;', 'background: #86E5E4; padding:5px 0;');
export default SPlayer;